import PropTypes from "prop-types";

import {
  ElapsedTime,
  FullScreen,
  Mute,
  PlayPause,
  ProgressBar,
} from "./Actions";

export const ActionBar = ({
  show = true,
  playingStatus,
  videoRef = null,
  locale,
  buttons,
  wrapperRef = null,
  setIsFullScreen,
  actionBarRef,
  hideBar,
  isFullScreen,
}) => {
  if (!show) return null;

  return (
    <div
      ref={actionBarRef}
      className={`ITXVideo__actionBar ${playingStatus} ${
        hideBar ? "hide" : ""
      }`}
    >
      <PlayPause
        buttons={buttons}
        locale={locale}
        playingStatus={playingStatus}
        videoRef={videoRef}
      />
      <ElapsedTime buttons={buttons} videoRef={videoRef} />
      <ProgressBar buttons={buttons} videoRef={videoRef} />
      <Mute buttons={buttons} locale={locale} videoRef={videoRef} />
      <FullScreen
        isFullScreen={isFullScreen}
        buttons={buttons}
        locale={locale}
        wrapperRef={wrapperRef}
        videoRef={videoRef}
        setIsFullScreen={setIsFullScreen}
      />
    </div>
  );
};
ActionBar.propTypes = {
  show: PropTypes.bool,
  playingStatus: PropTypes.string.isRequired,
  videoRef: PropTypes.object,
  locale: PropTypes.string.isRequired,
  buttons: PropTypes.shape({
    play_pause: PropTypes.bool,
    time: PropTypes.bool,
    progress_bar: PropTypes.bool,
    fullScreen: PropTypes.bool,
    mute: PropTypes.bool,
  }),
  wrapperRef: PropTypes.object,
  setIsFullScreen: PropTypes.func,
  actionBarRef: PropTypes.object,
  hideBar: PropTypes.bool,
  isFullScreen: PropTypes.bool,
};
